import { createStyles, TableCell, Theme, withStyles } from "@material-ui/core";

export const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#55575A",
      color: "#EAEAEB",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);
